import Vue from 'vue';

export default {
    getSalaryEstimation(context, data) {
        return Vue.$axios.$post('v1/salary-estimation', data);
    },

    getSubscriptionTypes() {
        const url = 'v1/subscription-types';
        return Vue.$axios.$get(url);
    },
};
